import { type Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AUTH_REDIRECT_PATH, AuthRedirectComponent } from '@pecan/core';
import { locationDataResolver } from '@pecan/entities/location';
import { permissionGuard } from '@pecan/entities/permissions';
import { RootLayoutComponent } from '@pecan/layout';

export const APP_ROUTES: Route[] = [
    {
        path: AUTH_REDIRECT_PATH,
        component: AuthRedirectComponent,
    },
    {
        path: '',
        component: RootLayoutComponent,
        canActivate: [MsalGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: '',
                redirectTo: '/home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                canActivate: [permissionGuard],
                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                loadComponent: () => import('./pages/+home/home.component').then(m => m.HomeComponent),
            },
            {
                loadChildren: () => import('./pages/+license/routes/license.routes').then(m => m.routes),
                path: 'licenses',
                resolve: { locationData: locationDataResolver },
            },
            {
                loadChildren: () => import('./pages/+company/routes/companies.routes').then(m => m.routes),
                path: 'companies',
                resolve: { locationData: locationDataResolver },
            },
            {
                loadChildren: () => import('./pages/+user/routes/user.routes').then(m => m.routes),
                path: 'user-management',
            },
            {
                loadChildren: () => import('./pages/+updates/routes/updates.routes').then(m => m.routes),
                path: 'updates',
            },
            {
                loadChildren: () => import('./pages/+dashboard/routes/dashboard.routes').then(m => m.routes),
                path: 'dashboard',
            },
            {
                loadChildren: () => import('./pages/+reports/routes/reports.routes').then(m => m.routes),
                path: 'reports',
            },
            {
                loadChildren: () => import('./pages/+activities/routes/activities.routes').then(m => m.routes),
                path: 'activities',
            },
            {
                loadChildren: () => import('./pages/+profile/routes/profile.routes').then(m => m.routes),
                path: 'profile',
            },
            {
                loadChildren: () => import('./pages/+dealers/routes/dealers.routes').then(m => m.routes),
                path: 'dealers',
                resolve: { locationData: locationDataResolver },
            },
            {
                loadChildren: () => import('./pages/+addons/routes/addon.routes').then(m => m.routes),
                path: 'addons',
            },
            {
                loadChildren: () => import('./pages/+products/routes/products.routes').then(m => m.routes),
                path: 'products',
            },
        ],
    },
];
